"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _UTTouchableWithoutFeedback = _interopRequireDefault(require("../UTTouchableWithoutFeedback"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var WithTouch = function WithTouch(onClick) {
  return function (WrappedComponent) {
    return function PropsProxy(props) {
      var handleClick = function handleClick() {
        return onClick(props);
      };

      return onClick ? _react["default"].createElement(_UTTouchableWithoutFeedback["default"], {
        onClick: handleClick // eslint-disable-next-line react/prop-types
        ,
        className: "".concat(_stylesModule["default"].base, " ").concat(props.touchableClassName) // eslint-disable-next-line react/prop-types
        ,
        ref: props.touchableRef
      }, _react["default"].createElement(WrappedComponent, props)) : _react["default"].createElement(WrappedComponent, props);
    };
  };
};

WithTouch.propTypes = {
  onClick: _propTypes.func,
  touchableClassName: _propTypes.string,
  touchableRef: _propTypes.string
};
var _default = WithTouch;
exports["default"] = _default;